<div class="banner-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="banner-text text">
                    <h1>Candidate <span>List</span></h1>
                    <p>Connecting Worldwide Talents and Businesses</p>

                    <div class="banner-form-area">
                        <form>
                            <div class="row">
                                <!-- <div class="col-md-4">
                                    <div class="form-group">
                                        <label
                                            ><i class="fas fa-building"></i
                                        ></label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Search Name"
                                               [(ngModel)]="name"
                                            [ngModelOptions]="{standalone: true}"
                                        />
                                    </div>
                                </div> -->

                                <div class="col-lg-6">
                                    <div class="form-group mt-2">
                                        <ngx-select-dropdown
                                        [config]="CountryConfig"
                                        [options]="country_list"
                                        (change)="onSelectedCountry($event)"
                                    >
                                    </ngx-select-dropdown>
                                    </div>
                                </div>
    
                                <div class="col-lg-6">
                                    <div class="form-group mt-2">
                                        <ngx-select-dropdown
                                        [config]="CitiesConfig"
                                        [options]="city_list"
                                    
                                        (change)="onSelectedCity($event)"
                                    >
                                    </ngx-select-dropdown>
                                    </div>
                                </div>


                                <div class="col-md-12 mt-3 mb-3">
                                    <div class="form-group">
                                        <label
                                            ><i class="fas fa-tags"></i
                                        ></label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Search Category"
                                            [(ngModel)]="category"
                                            [ngModelOptions]="{
                                                standalone: true
                                            }"
                                            style="border: 2px solid #cacacd; border-radius: 4px; padding-left: 10px;"
                                        />
                                    </div>
                                </div>

                                <!-- <div class="col-md-6">
                                    <div class="form-group">
                                        <label
                                            ><i class="fas fa-globe"></i
                                        ></label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Search Country"
                                            [(ngModel)]="country"
                                            [ngModelOptions]="{
                                                standalone: true
                                            }"
                                            style="border: 2px solid #cacacd; border-radius: 4px; padding-left: 10px;"
                                        />
                                    </div>
                                </div> -->
                            </div>

                            <button
                                type="submit"
                                (click)="getAllEmployerCandidateList()"
                                class="btn banner-form-btn mt-4 me-3"
                            >
                                Search
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="container back-link">
    <a routerLink="/home" class="cursor_pointer h5"
        ><i class="fa fa-angle-double-left me-2"></i>Back</a
    >
</div> -->

<section class="job-area job-area-two pt-100">
    <div class="container">
        <div class="row">
            <ng-container *ngIf="candidateList?.length > 0; else noDataTemplate">
            <div
                class="col-lg-6"
                *ngFor="let data of candidateList; let i = index"
            >
                <div class="job-item">
                    <div class="job-inner align-items-center">
                        <div class="job-inner-left">
                            <ng-container *ngIf="!!data?.approvedEmployee?.statusApproved; else defaultName">
                                <h3>{{ data?.firstName }} {{ data?.middleName }} {{ data?.lastName }}</h3>
                            </ng-container>
                            <ng-template #defaultName>
                                <h3>{{data?.publicName}}</h3>
                            </ng-template>

                            <ul class="mt-3 unordered-list">
                                <li>
                                    <i class="fa fa-briefcase"></i
                                    > <b>Job Title :</b> {{ data?.jobTitle ? data?.jobTitle : "No Job Title Exist" }}
                                </li>
                                <li>
                                    <i class="fas fa-building"></i
                                    >{{ data?.category ? data?.category : "****" }}
                                </li>
                                <li *ngIf="data?.country && data.country !== 'undefined'">
                                    <i class="fa fa-globe"></i>
                                    {{ data?.country }} <span *ngIf="data?.city">({{data?.city}})</span> 
                                </li>
                                <li *ngIf="!!data?.approvedEmployee?.statusApproved">
                                    <i class="fa fa-envelope"></i
                                    >{{ data?.email ? data?.email : "****" }}
                                </li>
                                <li *ngIf="!!data?.approvedEmployee?.statusApproved">
                                    <i class="fa fa-phone"></i
                                    >{{ data?.phoneNumber ? data?.phoneNumber : "****"}}
                                </li>
                            </ul>

                            <ul class="mt-3 unordered-list">
                                <b>Experience</b
                                >:
                                <ng-container *ngIf="data?.yearsOfExperience?.length > 0 ; else noData">
                                <div
                                    *ngIf="data?.yearsOfExperience"
                                    class="mt-2"
                                >
                                    <span>
                                        <li
                                            *ngFor="
                                                let experience of data.yearsOfExperience
                                            "
                                        >
                                            <div
                                                class="d-flex justify-content-between w-100"
                                            >
                                                <div>
                                                    <h6>
                                                        {{
                                                            experience.jobTitle
                                                        }}
                                                    </h6>
                                                    <!-- <p>
                                                        {{
                                                            experience.companyName
                                                        }}
                                                    </p> -->
                                                </div>
                                                <div>
                                                    <ng-container
                                                        *ngIf="
                                                            experience?.endedMonth &&
                                                                experience?.endedYear;
                                                            else presentTemplate
                                                        "
                                                    >
                                                        <h6>
                                                            ({{
                                                                experience?.startedYear
                                                            }}) - ({{
                                                                experience?.endedYear
                                                            }})
                                                        </h6>
                                                    </ng-container>

                                                    <ng-template
                                                        #presentTemplate
                                                    >
                                                        <div>
                                                            <h6>
                                                                ({{
                                                                    experience?.startedYear
                                                                }}) - present
                                                            </h6>
                                                        </div>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </li>
                                    </span>
                                </div>
                            </ng-container>
                            <ng-template #noData>
                             <p>********</p>
                            </ng-template>
                            </ul>

                            <div >
                                <ul class="mt-3 unordered-list">
                                    <ng-container *ngIf="data?.skills?.length > 0; else noSkills">
                                        <b>Skills</b>
                                        <div *ngFor="let skills of data?.skills">
                                        <span>
                                            <!-- <b>Skills</b> : {{ data.skills.join(", ") }} -->
                                               {{skills?.skill}}
                                        </span>
                                    </div>
                                    </ng-container>
                                </ul>
                                <ng-template #noSkills>
                                    <p><b>Skills</b> :</p>
                                    <span>********</span>
                                </ng-template>
                                
                            </div>
                            <div class="d-flex justify-content-between">
                                <div>
                                    <a
                                        class="mt-3"
                                        [routerLink]="[
                                            '/employer/candidate-details',
                                            data?._id]"
                                        >View Profile<i
                                            class="icofont-swoosh-right"
                                        ></i
                                    ></a>
                                </div>
                                <div>
                                    <button
                                    *ngIf="!data?.approvedEmployee?.statusApproved"
                                        class="btn btn-sm btn-success mt-3"
                                        data-bs-toggle="modal"
                                        data-bs-target="#confirmRequestModal"
                                        (click)="candidateModalId(data?._id)"
                                    >
                                        Generate Request
                                    </button>
                                </div>

                                <!-- Modal -->
                                <div
                                    class="modal fade"
                                    id="confirmRequestModal"
                                    tabindex="-1"
                                    aria-labelledby="confirmRequestLabel"
                                    aria-hidden="true"
                                >
                                    <div class="modal-dialog modal-dialog-centered">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5
                                                    class="modal-title"
                                                    id="confirmRequestLabel"
                                                >
                                                    Confirmation
                                                </h5>
                                                <button
                                                    type="button"
                                                    class="btn-close"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                ></button>
                                            </div>
                                            <div class="modal-body">
                                                Are you sure you want to
                                                generate a request for this
                                                candidate?
                                            </div>
                                            <div class="modal-footer">
                                                <button
                                                    type="button"
                                                    class="btn btn-secondary"
                                                    data-bs-dismiss="modal"
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-success"
                                                    data-bs-dismiss="modal"
                                                    #cancelButtonRef
                                                    (click)="confirmGenerateRequest()"
                                                >
                                                <span *ngIf="loader">
                                                    <small
                                                        class="loadingspinner d-inline-block ms-2"
                                                        *ngIf="loader"
                                                    ></small>
                                                </span>
                                                    Yes, Generate
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-template #noDataTemplate>
            <div class="col-12 text-center mt-4">
                <h5>No Data Exist</h5>
            </div>
        </ng-template>
        </div>
    </div>

    <nav aria-label="Page navigation example pagination" class="pagination-nav">
        <ul class="pagination unordered-list">
            <li class="page-item" [class.disabled]="currentPage === 1">
                <a
                    class="page-link cursor_pointer"
                    (click)="onPageChange(currentPage - 1)"
                    aria-label="Previous"
                >
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>
    
            <li
                class="page-item"
                *ngFor="let page of (totalPages > 0 ? [].constructor(totalPages) : []); let i = index"
            >
                <a
                    class="page-link cursor_pointer"
                    (click)="onPageChange(i + 1)"
                >
                    {{ i + 1 }}
                </a>
            </li>
    
            <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a
                    class="page-link cursor_pointer"
                    (click)="onPageChange(currentPage + 1)"
                    aria-label="Next"
                >
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>
        </ul>
    </nav>
    

    <div class="pagination-controls pagination">
        <span>Page {{ currentPage }} of {{ totalPages }}</span>
    </div>
</section>
